export const CLIENT_NEWS_URL = `/news/`;
export const CLIENT_NEWS_BY_AUTHOR_URL = `/news/author/`;
export const CLIENT_NEWS_CATEGORY_URL = `/category/`;
export const CLIENT_CATEGORY_PAGE_URL = `/news/`;

export const CLIENT_EXPERT_URL = `/expert/`;
export const CLIENT_PREVIEW_URL = `/preview/`;

export const CLIENT_API_EXPERTS_OPINIONS_URL = '/main/materials/by-expert-url/';
export const CLIENT_API_EXPERTS_OPINIONS_KEY = 'client_experts_opinions_select';

export const CLIENT_API_NEWS_MATERIALS_URL = '/main/materials/';
export const CLIENT_API_NEWS_MATERIALS_KEY = 'client_news_select_materials';

export const CLIENT_API_NEWS_CATEGORIES_URL = '/main/categories/';
export const CLIENT_API_NEWS_CATEGORIES_KEY = 'client_news_select_categories';

export const CLIENT_API_NEWS_BY_AUTHOR_URL = '/main/materials/?author=';
export const CLIENT_API_NEWS_BY_AUTHOR_KEY = 'client_news_select_by_author';

export const CLIENT_API_PREVIEW_BY_HASH_URL = '/main/preview/by_hash/';
export const CLIENT_API_PREVIEW_BY_HASH_KEY = 'client_news_preview_by_hash';

export const CLIENT_TAG_AI_URL = `/tag/ai/`;
export const CLIENT_TAG_URL = `/tag/`;

export const CLIENT_API_TAG_DETAIL_URL = '/main/tags/';
export const CLIENT_API_TAG_DETAIL_KEY = 'client_tag_detail';

export const CLIENT_API_TAG_MATERIALS_KEY = 'client_tag_materials';

export const CLIENT_API_SECTOR_DETAIL_URL = '/main/sector/';
export const CLIENT_API_SECTOR_DETAIL_KEY = 'client_sector_detail';

export const CLIENT_API_SECTOR_MATERIALS_KEY = 'client_sector_materials';
